<template>
    <div>
        <Navigation />
        <section class="section__container spacer-8">

            <h1 class="title center__text">Commercial(e) Sédentaire</h1>
            <div class="requirements container">
                <h3 class="requirements__title">Rejoignez notre équipe dès maintenant</h3>
                
                <p class="requirements__title">En tant que responsable du développement commercial 
                    de SERVICES-SMS, vous relèverez directement auprès des fondateurs. Vos principales
                     cibles seront les grandes entreprises et <br/>les startups.<br/>
                     
                     Pour réussir dans cette mission, nous vous offrirons un soutien complet dans vos 
                     activités de prospection téléphonique, notamment une formation initiale, un support 
                     marketing, et une assistance à la prospection. Cependant, il est essentiel d'être 
                     constamment à l'affût de <br/>nouvelles opportunités.   
                </p>
                
                <p class="requirements__title">Après avoir suivi une formation complète et en capitalisant
                     sur notre expertise et nos réseaux établis, votre action se concentrera principalement sur :
                </p>

                <ul>
                    <li>Poursuivre la recherche et l'élargissement de votre base de clients avec une mentalité <br/>axée sur la conquête et la croissance</li>
                    <li>Diriger le processus de vente de manière continue, en concluant la plupart de vos transactions par téléphone</li>
                    <li>Fournir des conseils stratégiques aux prospects concernant les possibilités offertes par <br/>nos solutions et illustrer la valeur de leur retour sur investissement (ROI)</li>
                    <li>Garantir un suivi régulier en rapportant de manière systématique vos actions et les<br/> résultats obtenus</li>
                </ul>
                
                <h3 class="requirements__title">Profil recherché</h3>
                
                <ul>
                    <li>Si vous avez une formation en commerce et une expérience initiale en vente, que ce <br/>soit par le biais de stages ou de votre premier emploi, de préférence dans les secteurs des services aux entreprises, et si vous trouvez votre épanouissement dans l'acquisition de nouveaux clients grâce à la prospection, alors vous pourriez être la personne que nous recherchons. Cependant, ce qui fera vraiment la différence, c'est votre motivation à vendre des solutions web et votre aisance relationnelle au téléphone.</li>
                    <li>Actuellement, vous êtes à la recherche d'un environnement professionnel en plein essor, <br/>où l'initiative et l'adaptabilité constantes sont requises, tout en offrant des opportunités d'évolution.</li>
                    <li>Votre emplacement géographique est à Dakar.</li>
                    
                </ul>
                <h3 class="requirements__title">De bonnes raisons pour nous rejoindre ?</h3>
                
                <ul>
                    <li>Une start-up en expansion avec une clientèle renommée en augmentation.</li>
                    <li>Une entreprise en phase d'accélération qui a les ressources nécessaires pour réaliser ses ambitions</li>
                    <li>Des opportunités de développement réelles qui s'offrent à vous</li>
                    <li>Une équipe déterminée à surmonter tous les obstacles pour devenir un leader</li>
                    
                </ul>
                
                
                <div class="other__requirements">
                    <h3>Comment postuler ?</h3>
                    <p>Pour candidater à ce poste, veuillez inclure votre CV en l'attachant à un e-mail adressé à

                        <a href="mailto:recrutement@servicesms.sn">recrutement@servicesms.sn</a>
                        , en utilisant comme objet " Commercial(e) Sédentaire".
                    </p>

                </div>

            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Navigation from './Navigation';
import Footer from './Footer';
export default {
    components: {
        Navigation,
        Footer
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';

.requirements {
    box-shadow: 0 67px 139px 28px rgba(0, 0, 0, .05);
    border-radius: 25px 25px 25px 0;
    
}

.requirements__title {
    padding-left: 2rem;
    padding-top: 1rem;
}

.other__requirements {
    padding-left: 1rem;
    padding-bottom: 4rem;
}

li {
    list-style-type: none;
}

li::before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../public/images/picto-list.svg) no-repeat center;
    padding-left: 2rem;
}

@media(min-width: 65rem) {
    .requirements {
        width: 60%;
        margin: 3rem auto;
    }

    .spacer-8 {
        margin-top: 8rem;
    }
    .title{
        padding-top: 3rem;
    }
}</style>